// Module
var code = "<div class=\"widget-content relative\"> <wt-horizontal-categorical-chart class=\"fill\" component-id=\"{{vm.id}}\" data=\"vm.data\" options=\"vm.options\" series=\"vm.series\"></wt-horizontal-categorical-chart> </div>";
// Exports
module.exports = code;